import { render } from "./TheVehicleMessages.vue?vue&type=template&id=2a01f39e"
import script from "./TheVehicleMessages.vue?vue&type=script&lang=js"
export * from "./TheVehicleMessages.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__